export default function ExecSvg({ size = 28, color = "#1478E3" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 307 307"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M152.564 188.998C197.001 188.998 233.295 154.135 235.587 110.268C235.714 107.837 237.676 105.86 240.111 105.86H286.718C289.153 105.86 291.134 107.845 291.058 110.278C288.725 184.76 227.612 244.424 152.564 244.424C77.5152 244.424 16.402 184.76 14.0691 110.278C13.9929 107.844 15.9739 105.86 18.4088 105.86H65.0166C67.4515 105.86 69.4133 107.837 69.5403 110.268C71.8318 154.135 108.126 188.998 152.564 188.998Z"
        fill={color}
      />
      <circle cx="153" cy="106.297" r="44.2967" fill={color} />
    </svg>
  );
}
